import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3584b102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-reference no-mb" }
const _hoisted_2 = { class: "product-image-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "product-info" }
const _hoisted_5 = { class: "product-price-info" }
const _hoisted_6 = { class: "product-price no-mb" }
const _hoisted_7 = { class: "product-vat-rate" }
const _hoisted_8 = {
  key: 1,
  class: "product-max-qty"
}
const _hoisted_9 = { class: "product-additional-info" }

import { computed, ref } from 'vue'
import { WarningOutlined, ZoomInOutlined } from '@ant-design/icons-vue'
import { ModularProduct } from '@/types/v2/modular/modularProduct'
import { CarcassProduct } from '@/types/v2/carcass/carcassProduct'
import { CompletionTwoProduct } from '@/types/v2/completion2/completionTwoProduct'
import { CompletionThreeProduct } from '@/types/v2/completion3/completionThreeProduct'
import { modularStore } from '@/stores/v2/modular'
import { carcassStore } from '@/stores/v2/carcass'
import { completion2Store } from '@/stores/v2/completion2'
import { completion3Store } from '@/stores/v2/completion3'

type ModularStoreType = ReturnType<typeof modularStore>
type CarcassStoreType = ReturnType<typeof carcassStore>
type Completion2StoreType = ReturnType<typeof completion2Store>
type Completion3StoreType = ReturnType<typeof completion3Store>


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononListProduct',
  props: {
    store: null,
    product: null,
    isConfigurable: { type: Boolean },
    showImage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  store:ModularStoreType|CarcassStoreType|Completion2StoreType|Completion3StoreType
  product:ModularProduct|CarcassProduct|CompletionTwoProduct|CompletionThreeProduct
  isConfigurable:boolean
  showImage?:boolean
};



const productQty = ref(props.product.qty)

const productQtyList = computed(() => {
  const list = []
  const step = props.product.step_qty
  const max = props.product.max_qty || 99

  if (step > 0) {
    for (let qty = step; qty <= max; qty += step) {
      list.push(qty)
    }
  }

  return list
})

function multipleQtyAllowed (product:{ max_qty:number, disabled:boolean }) : boolean {
  return product.max_qty > 1 && !product.disabled
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "desktop-product-card",
    size: "small"
  }, {
    title: _withCtx(() => [
      (multipleQtyAllowed(__props.product))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(__props.product.qty) + "x", 1)
          ], 64))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.product.commercial_name) + " ", 1),
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.product.reference), 1)
    ]),
    extra: _withCtx(() => [
      (multipleQtyAllowed(__props.product) && __props.isConfigurable)
        ? (_openBlock(), _createBlock(_component_a_select, {
            key: 0,
            class: "mr-8",
            style: {"width":"60px"},
            disabled: __props.store.savingProductId === __props.product.id || __props.store.phaseClosed,
            value: productQty.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((productQty).value = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (__props.store.updateProductQty(__props.product, productQty.value)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productQtyList), (qty) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: qty,
                  value: qty
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(qty), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["disabled", "value"]))
        : _createCommentVNode("", true),
      (!__props.product.selected && __props.isConfigurable)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            loading: __props.store.savingProductId === __props.product.id,
            disabled: __props.product.disabled || __props.store.saving || __props.store.phaseClosed,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.product.phase === 'completion2' ? __props.store.selectProduct(__props.product.id) : __props.store.toggleProduct(__props.product.id, productQty.value)))
          }, {
            default: _withCtx(() => [
              (__props.product.disabled)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(__props.store.phaseClosed ? 'Niet gekozen' : 'Niet beschikbaar'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(__props.store.phaseClosed ? 'Niet gekozen' : 'Kies'), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true),
      (__props.product.selected && __props.isConfigurable)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            type: "selected",
            loading: __props.store.savingProductId === __props.product.id,
            disabled: __props.product.disabled || __props.store.saving || __props.store.phaseClosed || __props.product.phase === 'completion2',
            onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.product.phase !== 'completion2' ? __props.store.toggleProduct(__props.product.id, 0) : null))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Gekozen")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        class: "no-mb",
        gutter: [16,16]
      }, {
        default: _withCtx(() => [
          (__props.showImage)
            ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0,
                span: 4
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_a_image, {
                      src: __props.product.images.main?.url || '/img/No_Image.png',
                      width: "100%"
                    }, {
                      previewMask: _withCtx(() => [
                        _createVNode(_unref(ZoomInOutlined))
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, {
            span: __props.showImage ? 14 : 18
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "commercial-description",
                innerHTML: __props.product.commercial_description || 'Geen omschrijving beschikbaar.'
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }, 8, ["span"]),
          _createVNode(_component_a_col, { span: 6 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, [
                    (__props.product.max_qty > 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(productQty.value) + " x ", 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(__props.product.customer_price_text), 1)
                  ]),
                  _createElementVNode("p", _hoisted_7, "incl. " + _toDisplayString(__props.product.vat_rate_text) + " BTW", 1),
                  (__props.product.step_qty > 1)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["product-max-qty", __props.product.max_qty > 1 ? 'no-mb' : ''])
                      }, "Verkoop per " + _toDisplayString(__props.product.step_qty) + " " + _toDisplayString(__props.product.unit === 'square_meter' ? 'm2' : 'stuks'), 3))
                    : _createCommentVNode("", true),
                  (__props.product.max_qty > 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Max. " + _toDisplayString(__props.product.max_qty) + " " + _toDisplayString(__props.product.unit === 'square_meter' ? 'm2' : 'stuks'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (__props.product.is_excluded_from_warranty)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "right"
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode("Let op! Dit product is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(WarningOutlined), { style: {"color":"#f38929"} })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (__props.product.is_default)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#f38929",
                        style: {"margin-left":"8px","margin-right":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Standaard")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})